module.exports = __webpack_public_path__ + "static/media/bgi-openscout-devstarXD-10@2x.f6fa8473.png";